import { useState } from 'react';
import { useLocale } from '../../../context/NbLocalizationContext';
import { NbButton } from '../../../shared/components/button/Button';
import { NbSwitch } from '../../../shared/components/toggle-button/Switch';
import { ConsentStatus, useConsent } from '../services/useConsent';
import classes from './CookieConsent.module.scss';

export const CookieConsent = () => {
  const { getCookieConsent, acceptCookieConsent, rejectCookieConsent } = useConsent();
  const [consentStatus, setConsentStatus] = useState(getCookieConsent());
  const [isShowDetails, setIsShowDetails] = useState<boolean>(false);
  const [isStatisticsCookiesAllowed, setIsStatisticsCookiesAllowed] = useState<boolean>(false);
  const [shouldSendConsentedCookies, setShouldSendConsentedCookies] = useState<boolean>(true);
  const { translation } = useLocale();

  const saveCookies = () => {
    if (isStatisticsCookiesAllowed || shouldSendConsentedCookies) {
      setConsentStatus(ConsentStatus.Consented);
      acceptCookieConsent();
    } else {
      setConsentStatus(ConsentStatus.Rejected);
      rejectCookieConsent();
    }
  };

  const onShowDetails = () => {
    setShouldSendConsentedCookies(false);
    setIsShowDetails(!isShowDetails);
  };

  const toggleStatisticsCookies = () => {
    setIsStatisticsCookiesAllowed(!isStatisticsCookiesAllowed);
  };

  if (consentStatus) {
    return <></>;
  }

  return (
    <div className={classes.consentContainer}>
      <div className={classes.consentWrapper}>
        <div className={classes.consentHeader}>
          <h2>{!isShowDetails ? translation.app.consent.header : translation.app.consent.headerDetails}</h2>
        </div>
        {!isShowDetails && (
          <div className={`${classes.consentText} ${!isShowDetails ? classes.consentTextIsTeaser : ''}`}>
            <span>{translation.app.consent.textHTML}</span>
            <span className={classes.consentTextMoreInfo}>
              <a
                href="https://www.erstemarket.hu/oldalak/cookie-policy"
                target={'_blank'}
                rel="noopener noreferrer"
              >
                {translation.app.consent.moreInfo}
              </a>
            </span>
          </div>
        )}

        {isShowDetails && (
          <div className={classes.details}>
            <div className={classes.detailsSection}>
              <div className={classes.detailsSectionHeader}>
                <h4>{translation.app.consent.comfyTitle}</h4>
                <NbSwitch
                  defaultChecked
                  disabled
                  color={'secondary'}
                />
              </div>
              <p>{translation.app.consent.comfyDescription}</p>
              <a
                href="https://www.erstemarket.hu/oldalak/cookie-policy"
                target={'_blank'}
                rel="noopener noreferrer"
                className={classes.detailsSectionLink}
              >
                {translation.app.consent.comfyLink}
              </a>
            </div>

            <div className={classes.detailsSection}>
              <div className={classes.detailsSectionHeader}>
                <h4>{translation.app.consent.statTitle}</h4>
                <NbSwitch
                  color={'secondary'}
                  checked={isStatisticsCookiesAllowed}
                  onChange={toggleStatisticsCookies}
                />
              </div>
              <p>{translation.app.consent.statDescription}</p>
              <a
                href="https://www.erstemarket.hu/oldalak/cookie-policy"
                target={'_blank'}
                rel="noopener noreferrer"
                className={classes.detailsSectionLink}
              >
                {translation.app.consent.statLink}
              </a>
            </div>
          </div>
        )}

        <div className={`${classes.actions} ${isShowDetails ? classes.actionsIsRight : ''}`}>
          {!isShowDetails && (
            <NbButton
              variant={'text'}
              size={'small'}
              onClick={onShowDetails}
              className={classes.actionsIsSettings}
              data-text={'customize'}
            >
              {translation.app.consent.cookieSettings}
            </NbButton>
          )}
          <NbButton
            className={classes.actionsIsAccept}
            onClick={saveCookies}
            data-text={'acceptAll'}
            data-testid="cookie-consent-accept-all"
          >
            {!isShowDetails ? translation.app.consent.allowAll : translation.app.consent.allowSettings}
          </NbButton>
        </div>
      </div>
    </div>
  );
};
